import React from 'react';
// import data
import { cta } from '../data';
// import icons
// import { HiOutlineChevronDown } from 'react-icons/hi';

const Cta = () => {
  // destructure cta data
  const { title, subRakk, subMars, img1, img2 } = cta;
  return (
    <section className='section bg-cta bg-cover bg-left-top'>
      <div className='max-w-[1340px] mx-auto px-[25px]'>
        {/* text */}
        <div className='max-w-[920px] mx-auto text-center'>
          <h2
            className='h2 text-white mb-6'
            data-aos='fade-up'
            data-aos-delay='200'
          >
            {title}
          </h2>

        </div>
        {/* btn & images */}
        <div className='flex flex-col lg:flex-row lg:gap-x-[30px] gap-y-[30px] lg:gap-y-0 justify-center items-center'>
          <div className='w-full h-full p-[40px] place-content-center mx-auto'>
            <img
              className='w-[35%] object-center mx-auto '
              src={img1}
              alt='rakkpro'
              data-aos='zoom-out-right'
              data-aos-delay='700'
            />
            <p
              className=' text-white text-center mt-5'
              data-aos='fade-up'
              data-aos-delay='300'
            >
              {subRakk}
            </p>
          </div>
          <div className='w-full h-full p-[40px] '>
            <img
              className='block w-[50%]  mx-auto'
              src={img2}
              alt='mars'
              data-aos='zoom-out-left'
              data-aos-delay='700'
            />
            <p
              className=' text-white text-center justify-center items-center'
              data-aos='fade-up'
              data-aos-delay='300'
            >
              {subMars}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cta;
